import { onePxElevation, threePxElevation } from "../elevation";
export var hoverRaise = "\n  cursor: pointer;\n  " + onePxElevation + "\n  transition: all .15s;\n  &:hover {\n    transform: translateY(-3px);\n    " + threePxElevation + "\n  }";
